
import LazyImage from '../../../components/LazyImage.vue';
import matchHeight from '../../../directives/match-height';
import Price from '../../../components/price/Price.vue';
import ProductFlag from './ProductFlag.vue';
import ProductStockInfo from './ProductStockInfo.vue';
import ProductSwatches from './swatches/ProductSwatches.vue';
import PromoLabel from './promos/PromoLabel.vue';
import ReviewStars from '../../../components/ReviewStars.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';
import { getPriceMode, IListableProductJson, IProductSwatch } from '../../../types/Product';
import { HawkTrackingProductClickRequest } from '../../../types/HawkSearch';
import { IOrderProductJson } from '../../../types/Order';

@Component({
	name: 'ProductSummaryCard',
	components: {
		Price,
		ProductSwatches,
		ReviewStars,
		PromoLabel,
		ProductFlag,
		LazyImage,
		ProductStockInfo,
	},
	directives: {
		matchHeight
	}
})
export default class ProductSummaryCard extends Vue {

	/* Props
	============================================*/
	@Prop({ type: Object as () => IListableProductJson, required: true })
	product: IListableProductJson;

	@Prop({ type: Number })
	hawkIndex: number; // used for tracking in hawk search

	@Prop({ type: String })
	itemListId: string;

	@Prop({ type: String })
	itemListName: string;

	/* Computed
	============================================*/
	@Get('productsInCart')
	productsInCart: IOrderProductJson[];

	get wrapperClasses() {
		return [
			'psc-wrapper',
			{
				'no-flag': !this.hasFlag,
			}
		];
	}

	get productImage(): string {
		return this.activeProductImage ? this.activeProductImage : this.product.imageUrl;
	}

	get productImageWebp(): string {
		return this.activeProductImage ? this.activeProductImageWebp : this.product.imageUrlWebp;
	}

	get flagText(): string | null {
		// TODO: add more conditions when we implement other flags like 'Top Seller'
		if (this.product.price?.isClearance) return 'Clearance';

		return this.product.promo?.flagText;
	}

	get hasFlag(): boolean {
		return !!this.flagText;
	}

	get isMobile() {
		return this.$mq === 'mobile';
	}

	get activeProductImage() {
		return this.activeSwatch?.largeImage;
	}

	get activeProductImageWebp() {
		return this.activeSwatch?.largeImageWebp;
	}

	get activeSwatchColor() {
		return this.activeSwatch ? this.activeSwatch.color : '';
	}

	get productImageAltText() {
		const color = this.activeSwatch?.color;

		let prefix = '';
		if (color) {
			prefix = `Showing ${color} variant of `;
		} else {
			prefix = 'Photo of ';
		}

		return prefix + this.product.productName;
	}

	get isProductInCart(): boolean {
		return !!this.productsInCart?.find(
			product => product.blainNumber === this.product.blainNumber
			           || (this.product.groupID && product.groupID === this.product.groupID)
		);
	}

	/* Data
	============================================*/
	activeSwatch: IProductSwatch = null;
	shouldImageTransition: boolean = true;

	/* Methods
	============================================*/
	onSwatchChange(swatch: IProductSwatch) {
		this.activeSwatch = swatch;
		this.shouldImageTransition = false;
	}

	onProductLinkClick(event) {
		const productTrackingRequest: HawkTrackingProductClickRequest = {
			event,
			blainNumber: this.product.blainNumber,
			index: this.hawkIndex,
			vendorBrand: this.product.vendorBrand,
			productName: this.product.productName,
			currentPrice: this.product.sellingPrice,
			mapSafePrice: this.product.mapSafePrice, 
			belowMap: this.product.price.isBelowMAP,
			priceMode: getPriceMode(this.product.price),
			itemListID: this.itemListId,
			itemListName: this.itemListName
		};
		this.$emit('product-link-click', productTrackingRequest);
	}

	beforeMount() {
		if (this.product.productSwatches.length <= 1) return;
		this.activeSwatch = this.product.productSwatches.find(ps => ps.largeImage == this.product.imageUrl);
	}

}
